<div class="card trade_card h-100 d-flex flex-column border border-secondary" style="background-color: #1e2026;">

  <div class="card-header d-flex justify-content-between align-items-center py-2 border-bottom border-secondary"
    style="flex-shrink: 0; min-height: 50px; background-color: #1e2026;">
    <h5 class="mb-0 text-white">Open Position</h5>
    <span class="badge bg-dark border border-secondary text-secondary" *ngIf="botPositionHistory.length > 0">
      {{ botPositionHistory.length }}
    </span>
  </div>

  <div class="card-body p-0 position-relative" style="flex-grow: 1; overflow: hidden;">

    <div *ngIf="isPosLoading" class="d-flex justify-content-center align-items-center h-100 w-100">
      <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div class="table-container custom-scrollbar" *ngIf="!isPosLoading && botPositionHistory.length > 0"
      style="position: absolute; top: 0; bottom: 0; left: 0; right: 0; overflow-y: auto; overflow-x: hidden;">

      <table class="table custom-table table-borderless align-middle mb-0 w-100 text-white">

        <thead class="sticky-top" style="z-index: 10;">
          <tr class="text-secondary" style="font-size: 0.75rem; border-bottom: 1px solid #2a2e39;">
            <th class="ps-3 py-2 text-white" style="background-color: #161a1e;">Pair</th>
            <th class="text-end py-2 text-white" style="background-color: #161a1e;">Profit %</th>
            <th class="text-end py-2 pe-3 text-white" style="background-color: #161a1e;">Action</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let data of botPositionHistory" class="position-row border-bottom border-secondary">
            <td class="ps-3">
              <span class="fw-bold text-white pointer" (click)="loadChart(data.symbol)">{{ data.symbol }}</span>
            </td>
            <td class="text-end">
              <div *ngIf="data?.esProfit !== undefined">
                <span [ngClass]="data.esProfit < 0 ? 'text-danger' : 'text-success'" class="fw-bold">
                  {{ data.esProfit | number:'1.2-4' }}
                </span>
                <div class="small text-secondary" style="font-size: 0.7rem;">({{ data.profitPercent }}%)</div>
              </div>
              <span *ngIf="data?.esProfit === undefined" class="text-secondary">-</span>
            </td>
            <td class="text-end pe-3">
              <div class="d-flex justify-content-end gap-2">
                <button class="btn btn-sm btn-outline-secondary py-0 px-2" style="font-size: 0.75rem;"
                  *ngIf="data?.status == 'open'" (click)="cancelAndWait(data)" [disabled]="cancelLoader">
                  Keep
                </button>
                <button class="btn btn-sm btn-danger py-0 px-2" style="font-size: 0.75rem;"
                  (click)="cancel('position','market',data)" [disabled]="cancelLoader">
                  Sell
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!isPosLoading && botPositionHistory.length == 0"
      class="d-flex flex-column justify-content-center align-items-center h-100 w-100 text-secondary"
      style="position: absolute; inset: 0;">
      <img src="assets/images/no_records_found.png" alt="No Data" class="mb-3 opacity-50" style="width: 50px;">
      <p class="mb-0 small text-uppercase" style="letter-spacing: 1px;">No Open Positions</p>
    </div>

  </div>
</div>